export const isGymWorkspace = (workspace = {}) => {
  if (workspace.is_school) return false;
  const settings = workspace.settings || {};
  return workspace.is_gym === true ||
    [settings.category, settings.segment, settings.dashboardStyle].some((value) =>
      ["gym", "fitness_centre", "sports_centre"].includes(String(value || "").toLowerCase()));
};

const steps = (value) => Math.max(0, Number(value) || 0);
export const buildGymDashboard = (dashboard = {}) => {
  const workspace = dashboard.workspace || {};
  const locked = workspace.steps_locked === true || workspace.access_active === false;
  const rank = (rows) => [...(rows || [])].sort((a, b) => locked
    ? String(a.name || "").localeCompare(String(b.name || ""))
    : steps(b.steps) - steps(a.steps) || String(a.name || "").localeCompare(String(b.name || "")));
  const members = rank(dashboard.members);
  const groups = rank((dashboard.teams || []).filter((team) => team.kind !== "challenge"));
  const challenges = rank((dashboard.teams || []).filter((team) => team.kind === "challenge"));
  const summary = workspace.settings?.demo_seed ? {} : workspace.activity_summary || {};
  const memberCount = summary.member_count == null ? members.length : steps(summary.member_count);
  const totalSteps = locked ? null : summary.total_steps == null
    ? members.reduce((sum, member) => sum + steps(member.steps), 0) : steps(summary.total_steps);
  const image = [workspace.venue_image_url, workspace.settings?.coverImageUrl,
    ...groups.map((group) => group.image), ...challenges.map((challenge) => challenge.image)]
    .find((url) => url && url !== workspace.logo_url) || "";
  return { workspace, locked, members, groups, challenges, memberCount, totalSteps,
    averageSteps: locked ? null : memberCount ? Math.round(totalSteps / memberCount) : 0,
    leader: locked ? null : members.find((member) => steps(member.steps) > 0) || null, image };
};
